import base from '../dr-base'
import drFilter from './dr-filter.vue'

const schema = {
  $Type: 'dr-filter',
  name: 'Filter',
  group: 'Common widgets',
  icon: 'mouse-alt',
  ...base,
  properties: {
    ...base.properties,
    Fields: {
      name: 'vuetifyWidgets.dr-filter.listOfFilters',
      type: 'array',
      component: 'dr-filter-fields-editor'
    },
    DataWidget: {
      name: 'vuetifyWidgets.dr-filter.dataWidgetId',
      type: 'string'
    },
    Caption: {
      name: 'vuetifyWidgets.dr-filter.caption',
      type: 'string',
      default: 'Filter by:'
    }
  }
}

export default {
  schema,
  component: drFilter,
  propEditor: [
    {
      name: 'dr-filter-fields-editor'
    }
  ]
}